module.exports = __webpack_public_path__ + "fonts/Nunito-LightItalic.e62fa715.ttf";